import { EmailInputWFDModalButtonsProps, WFDModalButtonsProps } from 'shared/types/cart/Narvar';
import InputField from '@/components/customercenter-ui/common/validateForm/inputField';
import { useCheckout } from '@/context/checkoutProvider';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

export const AddOrDeclineWFDModalButtons = ({
  onAdd,
  onDecline,
  email,
  orderHasEmail,
  trigger,
}: Readonly<WFDModalButtonsProps>) => {
  const handleAddClick = async () => {
    if (!orderHasEmail) {
      const valid = await trigger('email');
      if (!valid) {
        return;
      }
    }
    onAdd(email);
  };

  return (
    <>
      <button
        type="button"
        className="rounded bg-[#002C4E] px-4 py-3 text-[16px] font-semibold text-white"
        onClick={handleAddClick}
      >
        {mapLocaleToMeaningfulFormat()?.addWorryFreeDelivery}
      </button>

      <button
        type="button"
        className="text-[16px] font-medium text-[#404040] underline underline-offset-2"
        onClick={onDecline}
      >
        {mapLocaleToMeaningfulFormat()?.declineWorryFreeDelivery}
      </button>
    </>
  );
};

export const EmailInputWFDModalButtons = ({
  email,
  setEmail,
  register,
  errors,
}: Readonly<EmailInputWFDModalButtonsProps>) => {
  const { setContactInformation, contactInformation } = useCheckout();
  const handleEmailChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setContactInformation({
      ...contactInformation,
      email: newEmail,
    });
  };

  return (
    <section className="w-full lg:w-[80%]">
      <InputField
        id="emailAddress"
        htmlFor="emailAddress"
        label="email"
        onChange={handleEmailChange}
        value={email}
        items="*Email Address"
        register={register}
        classname="w-full"
        errors={errors}
        placeholder="*Email Address"
      />
    </section>
  );
};
